import { AbsensiProvider } from "./AbsensiContext";
import { CutiProvider } from "./CutiContext";
import { DashboardProvider } from "./DashboardContext";
import { DokumenProvider } from "./DokumenContext";
import { KalenderProvider } from "./KalenderContext";
import { PengumumanProvider } from "./PengumumanContext";
import { RoleProvider } from "./RoleContext";
import { SlipGajiProvider } from "./SlipGajiContext";
import { StafProvider } from "./StafContext";
import { TandaTerimaProvider } from "./TandaTerimaContext";

const AppProvider = ({ children }) => {
  return (
    <RoleProvider>
      <AbsensiProvider>
        <DashboardProvider>
          <StafProvider>
            <TandaTerimaProvider>
              <SlipGajiProvider>
                <CutiProvider>
                  <PengumumanProvider>
                    <DokumenProvider>
                      <KalenderProvider>{children}</KalenderProvider>
                    </DokumenProvider>
                  </PengumumanProvider>
                </CutiProvider>
              </SlipGajiProvider>
            </TandaTerimaProvider>
          </StafProvider>
        </DashboardProvider>
      </AbsensiProvider>
    </RoleProvider>
  );
};

export default AppProvider;